export const scrollTo = (top, left, behavior) => {
  try {
    window.scrollTo({
      top,
      left,
      behavior,
    });
  } catch (error) {
    window.scrollTo(left, top);
  }
};

export const scrollToTop = (behavior = 'smooth') => {
  if (window.pageYOffset <= 0) return;
  scrollTo(0, 0, behavior);
};
